export default "__VITE_ASSET__DjVArU4u__"